import React from 'react';

import LandingLayout from '../../components/ui/LandingLayout';

const MobileInboxMessagesLayout: React.FC = () => (
  <LandingLayout
    titleId="root-TitleParentOnly"
    imageName="parent-only"
    subtitleId="root-SubtitleParentOnly"
    hasDownloadButtons
    hideSidebar
  />
);

export default MobileInboxMessagesLayout;
